export type Collection<T> = Readonly<{
  items: ReadonlyArray<T>
  next: string | null
  total: number
}>

export const emptyCollection = <T>(): Collection<T> => ({
  next: null,
  items: [],
  total: 0,
})

export const mapCollection = <A, B>({ items, ...rest }: Collection<A>, fn: (x: A) => B): Collection<B> => ({
  ...rest,
  items: items.map(fn),
})
